import { apiClientWithRefreshToken } from "@/api/apiClient";
import { Pagination, Client } from "@/v2/types";

export type ClientOption = Pick<Client, "id" | "full_name" | "short_code">;

// Lists all clients (id, name, short code) for mobilization filters,
// regardless of the user's client assignment.
export default async function FindAllMobilizationClientOptions({
    limit,
    skip,
    search,
}: {
    skip?: number;
    limit?: number;
    search?: string;
}): Promise<{ data: ClientOption[]; pagination: Pagination }> {
    const res = await apiClientWithRefreshToken({
        url: "/mobilizations/client-options",
        method: "GET",
        params: {
            skip: skip ?? 0,
            limit: limit ?? 10,
            ...(search && { search }),
        },
    });

    return res.data;
}
